import { forwardRef, SVGAttributes } from 'react'

export type ClipPathProps = SVGAttributes<SVGSVGElement>

const ClipPath = forwardRef<SVGSVGElement, ClipPathProps>(
  ({ id, ...props }, ref) => {
    return (
      <svg ref={ref} width="0" height="0" {...props}>
        <defs>
          <clipPath id={id} clipPathUnits="objectBoundingBox">
            <path d="M 0 0 L 1 0 L 1 1 L 0 1z" />
            {/* <path d="M 0 0.1 L 1 0 L 1 0.9 L 0 1z" /> */}
          </clipPath>
        </defs>
      </svg>
    )
  }
)

export default ClipPath
